const setCookie=(cname, cvalue, exdays,safe)=>{//设置cookie
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toUTCString();
  const sameS = safe?';SameSite=None;Secure':''
  document.cookie = cname + "=" + cvalue + "; " + expires+sameS;
}

const getCookie=(name)=>{//获取cookie中属性
  let strCookie = document.cookie;
  let arrCookie = strCookie.split(';');
  for(let i = 0; i < arrCookie.length; i++) {
      let arr = arrCookie[i].split('=');
      if(arr[0].replace(/(^\s*)|(\s*$)/g, "") == name) {
          return arr[1];
      }
  }
  return '';
}

const delCookie=(name)=>{
  setCookie(name, "", -1);
}

const getUuid=()=>{//随机生成uuid
  let s = [];
  let hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";
  let uuid = s.join("");
  uuid = uuid.split("-").join(""); //唯一会话id
  return uuid
}

const formatTime=(time)=>{//格式化时间
  var date = new Date(time)
  var Y = date.getFullYear() + '-'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  return Y + M + D + h + m + s
}

const transformTime=(time)=>{//转换时间戳
  var date = new Date(time);
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
  var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
  var strDate = Y + M + D + h + m + s;
  return strDate
}

export default {
  getCookie,getUuid,setCookie,delCookie,formatTime,transformTime
}


